export type FileItemStatus =
  | "uploaded"
  | "processed by tracker"
  | "uploading"
  | "verified"
  | "processing"
  | "processed";

export interface FileItem {
  id: string;
  uploadDate: string;
  name: string;
  type: "folder" | "pdf file" | "doc file";
  size: number; // in MB
  status: FileItemStatus;
  progress?: number; // only relevant if status is "uploading"
}

export const fileMocks: FileItem[] = [
  {
    id: "1",
    uploadDate: "2024-06-21T09:00:00Z",
    name: "Budget_Report_2024.pdf",
    type: "pdf file",
    size: 1.5,
    status: "uploaded",
  },
  {
    id: "2",
    uploadDate: "2024-06-22T10:00:00Z",
    name: "Gas law research",
    type: "folder",
    size: 0,
    status: "verified",
  },
  {
    id: "3",
    uploadDate: "2024-05-22T11:00:00Z",
    name: "Meeting_Notes.docx",
    type: "doc file",
    size: 0.8,
    status: "processed by tracker",
  },
  {
    id: "4",
    uploadDate: "2024-05-23T12:00:00Z",
    name: "Annual_Report.pdf",
    type: "pdf file",
    size: 2.3,
    status: "uploading",
    progress: 70,
  },
  {
    id: "5",
    uploadDate: "2024-05-24T09:00:00Z",
    name: "Legal_Contract.docx",
    type: "doc file",
    size: 1.2,
    status: "uploaded",
  },
  {
    id: "6",
    uploadDate: "2024-05-25T10:00:00Z",
    name: "Project_Plans 2",
    type: "folder",
    size: 0,
    status: "processed by tracker",
  },
  {
    id: "7",
    uploadDate: "2024-05-26T11:00:00Z",
    name: "Financial_Statement_2022.pdf",
    type: "pdf file",
    size: 3.5,
    status: "verified",
  },
  {
    id: "8",
    uploadDate: "2024-05-27T12:00:00Z",
    name: "Employee_Handbook.docx",
    type: "doc file",
    size: 1.0,
    status: "uploading",
    progress: 50,
  },
  {
    id: "9",
    uploadDate: "2024-05-28T13:00:00Z",
    name: "Company_Policies.pdf",
    type: "pdf file",
    size: 2.8,
    status: "uploaded",
  },
  {
    id: "10",
    uploadDate: "2023-05-29T14:00:00Z",
    name: "Training_Material.docx",
    type: "doc file",
    size: 1.3,
    status: "verified",
  },
  {
    id: "11",
    uploadDate: "2023-05-30T09:00:00Z",
    name: "Quarterly_Report_Q1.pdf",
    type: "pdf file",
    size: 1.7,
    status: "uploaded",
  },
  {
    id: "12",
    uploadDate: "2023-05-31T10:00:00Z",
    name: "Project_Charter",
    type: "folder",
    size: 0,
    status: "verified",
  },
  {
    id: "13",
    uploadDate: "2023-06-01T11:00:00Z",
    name: "Sprint_Planning.docx",
    type: "doc file",
    size: 0.9,
    status: "processed by tracker",
  },
  {
    id: "14",
    uploadDate: "2023-06-02T12:00:00Z",
    name: "Marketing_Strategy.pdf",
    type: "pdf file",
    size: 2.4,
    status: "uploading",
    progress: 60,
  },
  {
    id: "15",
    uploadDate: "2023-06-03T09:00:00Z",
    name: "HR_Policies.docx",
    type: "doc file",
    size: 1.1,
    status: "uploaded",
  },
  {
    id: "16",
    uploadDate: "2023-06-04T10:00:00Z",
    name: "Design_Prototypes",
    type: "folder",
    size: 0,
    status: "processed by tracker",
  },
  {
    id: "17",
    uploadDate: "2023-06-05T11:00:00Z",
    name: "Financial_Overview_2023.pdf",
    type: "pdf file",
    size: 3.6,
    status: "verified",
  },
  {
    id: "18",
    uploadDate: "2023-06-06T12:00:00Z",
    name: "Staff_Handbook.docx",
    type: "doc file",
    size: 1.1,
    status: "uploading",
    progress: 55,
  },
  {
    id: "19",
    uploadDate: "2023-06-07T13:00:00Z",
    name: "Internal_Audit_Report.pdf",
    type: "pdf file",
    size: 2.9,
    status: "uploaded",
  },
  {
    id: "20",
    uploadDate: "2023-06-08T14:00:00Z",
    name: "Employee_Training_Material.docx",
    type: "doc file",
    size: 1.4,
    status: "verified",
  },
  {
    id: "21",
    uploadDate: "2023-06-09T09:00:00Z",
    name: "Product_Roadmap.pdf",
    type: "pdf file",
    size: 1.8,
    status: "uploaded",
  },
  {
    id: "22",
    uploadDate: "2023-06-10T10:00:00Z",
    name: "Team_Meeting_Notes",
    type: "folder",
    size: 0,
    status: "verified",
  },
  {
    id: "23",
    uploadDate: "2023-06-11T11:00:00Z",
    name: "Client_Feedback.docx",
    type: "doc file",
    size: 0.9,
    status: "processed by tracker",
  },
  {
    id: "24",
    uploadDate: "2023-06-12T12:00:00Z",
    name: "Annual_Financial_Report.pdf",
    type: "pdf file",
    size: 2.7,
    status: "uploading",
    progress: 65,
  },
  {
    id: "25",
    uploadDate: "2023-06-13T09:00:00Z",
    name: "IT_Security_Policies.docx",
    type: "doc file",
    size: 1.0,
    status: "uploaded",
  },
  {
    id: "26",
    uploadDate: "2023-06-14T10:00:00Z",
    name: "New_Project_Plans",
    type: "folder",
    size: 0,
    status: "processed by tracker",
  },
  {
    id: "27",
    uploadDate: "2023-06-15T11:00:00Z",
    name: "Executive_Summary_2023.pdf",
    type: "pdf file",
    size: 3.2,
    status: "verified",
  },
  {
    id: "28",
    uploadDate: "2023-06-16T12:00:00Z",
    name: "Company_Handbook.docx",
    type: "doc file",
    size: 1.1,
    status: "uploading",
    progress: 45,
  },
  {
    id: "29",
    uploadDate: "2023-06-17T13:00:00Z",
    name: "Operational_Policies.pdf",
    type: "pdf file",
    size: 2.5,
    status: "uploaded",
  },
  {
    id: "30",
    uploadDate: "2023-06-18T14:00:00Z",
    name: "Training_Guidelines.docx",
    type: "doc file",
    size: 1.2,
    status: "verified",
  },
];
